import { Link } from "react-router-dom";
import { PageHero, CTABand, Reveal } from "@/components/chrome";
import { INSIGHTS } from "@/data/insights";
import { paths } from "@/lib/seo";

export default function InsightsIndex() {
  return (
    <div data-testid="insights-index-page">
      <PageHero
        prefix="insights-index"
        crumbs={[{ name: "Home", path: "/" }, { name: "Insights" }]}
        eyebrow="Insights & guides"
        title="Cleaning knowledge, written for Canada"
        lead="Costs, checklists, hiring guides and industry standards — practical reading from the crews who clean coast to coast."
      />
      <section className="mx-auto max-w-7xl px-5 py-16 sm:py-20">
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {INSIGHTS.map((post, i) => (
            <Reveal key={post.slug} delay={(i % 3) * 0.05}>
              <Link to={paths.insight(post.slug)} data-testid={`insight-card-${post.slug}`}
                className="group flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:border-cyan-600/40 hover:shadow-[0_16px_40px_-16px_rgba(2,132,199,0.25)]">
                <p className="font-mono text-xs uppercase tracking-[0.2em] text-cyan-700">{post.category} · {post.readMinutes} min read</p>
                <h2 className="mt-4 flex-1 font-display text-lg font-semibold leading-snug tracking-tight text-slate-900">{post.title}</h2>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">{post.excerpt}</p>
                <p className="mt-4 text-xs text-slate-400">{new Date(post.date).toLocaleDateString("en-CA", { year: "numeric", month: "long", day: "numeric" })}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <CTABand lead="Reading is optional. A spotless space is one phone call away." prefix="insights-cta" />
    </div>
  );
}
